const Passwords = [
    // Super admin
    {id: "admin123", password: "admin321", name: "alladmin"},
    // Aniq va tabiiy fanlar admin
    {id: "101101931", password: "aniqtabiyfan#y1931", name: "AniqTabiyFan"},
    // O'zbek va rus filologiyasi admin
    {id: "102101931", password: "uzrufil#y1931", name: "uzrufil"},
    // Xorijiy filologiya admin
    {id: "103101931", password: "xorijfilolog#y1931", name: "xorijfilolog"},
    // Pedagogika va ijtimoiy fanlar admin
    {id: "104101931", password: "pedijtfan#y1931", name: "pedijtfan"},
    // Amaliy fanlar admin
    {id: "105101931", password: "amaliyfan#y1931", name: "amaliyfan"},
    // Maktabgacha va boshlang'ich ta'lim admin
    {id: "106101931", password: "makboshtal#y1931", name: "makboshtal"},
    // Kechki ta'lim admin
    {id: "202201931", password: "kechki#y1931", name: "kechki"},
    // Sirtqi ta'lim admin
    {id: "203301931", password: "sirtqi#y1931", name: "sirtqi"},
]
export default Passwords;